// extracted by mini-css-extract-plugin
export var empty = "styles-module--empty--c7d23";
export var slots = "styles-module--slots--692ca";
export var title = "styles-module--title--ab1e0";